import React, {
  CSSProperties,
  KeyboardEventHandler,
  ReactElement,
} from "react";
import { Controller, RegisterOptions } from "react-hook-form";
import styled from "styled-components";
import { Input } from "components/beta/Input";
import Text, { TextType } from "components/Text";

const StyledStack = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  gap: 8px;
`;

interface Props {
  name: string;
  label?: string;
  rules?: Exclude<
  RegisterOptions,
  "valueAsNumber" | "valueAsDate" | "setValueAs"
  >;
  placeholder?: string;
  valueOverride?: string;
  type?: React.HTMLInputTypeAttribute;
  disabled?: boolean;
  width?: string;
  height?: string;
  style?: CSSProperties;
  onKeyUp?: KeyboardEventHandler<HTMLDivElement>;
}

export default function FormInput({
  name,
  label,
  rules,
  placeholder,
  valueOverride,
  type,
  disabled,
  style,
  width,
  height,
  onKeyUp,
}: Props): ReactElement {
  return (
    <StyledStack style={style ?? { marginBottom: "24px" }}>
      {label && (
        <Text type={TextType.TITLE_1} style={{ paddingBottom: "4px" }}>
          {label}
        </Text>
      )}
      <Controller
        name={name}
        rules={rules}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          const displayValue = value
            ? value
            : valueOverride
              ? valueOverride
              : undefined;
          return (
            <Input
              type={type}
              placeholder={placeholder ?? name}
              error={!!error}
              value={displayValue}
              onChange={onChange}
              onKeyUp={onKeyUp}
              disabled={disabled ?? false}
              width={width}
              height={height}
            />
          );
        }}
      />
    </StyledStack>
  );
}
